<div class="chest-sideflex">
    <div class="chest-left-wrap">
        <img src="/assets/images/v2/jackpot/baltymu-saltinis.png" class="chest-glow">
        <img src="/assets/images/v2/jackpot/open-chest/chest.svg" class="chest-image-dropdown">
    </div>
    <div class="chest-right-wrap">
        <h6 class="next-chest-in-heading">Chest in: {{ remainingWager | currency: 'USD' }}</h6>
        <div class="chest-wagered-progress-wrap big-wrap">
            <div class="chest-wagered-progress" [style.width]="progress + '%'"></div>
        </div>
        <div class="hero-chest-content">
            <div class="chest-cost-wrap">
                <img
                    src="/assets/images/jackpot/Key-Only.svg"
                    width="30" class="chest-small-icon">
                <div>{{ keys }}</div>
            </div>
            <div class="chest-cost-wrap">
                <img
                    src="/assets/images/v2/jackpot/open-chest/chest.svg"
                    width="30" class="chest-small-icon">
                <div>{{ chests }}</div>
            </div>
        </div>
        <a [routerLink]="['/', { outlets: { modal: 'open-chest' } } ]" *ngIf="chests">
            <app-form-button class="small default">Open chest</app-form-button>
        </a>
    </div>
</div>



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/header-navigation/chest-wager-mobile/chest-wager.template.html